import React from 'react'

import ShareYourIdea from '../../../react4xp/components/ShareYourIdea'

function ShareYourIdeaPart({title, intro, cta, colors}) {
    return (
		<ShareYourIdea
			section={{ 
				bgColor: colors.bgColor
			}}
			box={{
				title: title,
				content: intro,
				animatedCta: true,
				cta: {
					text: cta.text,
					href: cta.href
				}
			}}
		/>
    )
}

export default (props) => <ShareYourIdeaPart {...props} />
